/* eslint-disable react/no-array-index-key */
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Zoom from '@material-ui/core/Zoom';
import styled from 'styled-components';

const TooltipText = styled.div`
border: 1px solid #FFFFFF;
&: hover {
  border: 1px solid #BBBBBB;
}
`;

const HtmlTooltip = withStyles(({
  tooltip: {
    boxShadow: '0px 0px 10px 4px rgb(240,240,240)',
    backgroundColor: '#4F4F4F',
    borderRadius: '4px',
    color: 'white',
    width: '800px',
  },
}))(Tooltip);

function OptionTooltip(props) {
  return (
    <HtmlTooltip
      TransitionComponent={Zoom}
      title={
        <div style={{ padding: '10px', display: 'flex', width: '800px' }}>
          <div style={{ marginRight: '12px', color: 'white' }}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" width="16" height="16" viewBox="0 0 20 20">
              <path d="M9.5 16A6.61 6.61 0 0 1 3 9.5 6.61 6.61 0 0 1 9.5 3 6.61 6.61 0 0 1 16 9.5 6.63 6.63 0 0 1 9.5 16zm0-14A7.5 7.5 0 1 0 17 9.5 7.5 7.5 0 0 0 9.5 2zm.5 6v4.08h1V13H8.07v-.92H9V9H8V8zM9 6h1v1H9z" />
            </svg>
          </div>
          <div style={{ fontSize: '15px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '6px' }}>Change <strong>product size</strong> and <strong>copy</strong></div>
            <div style={{ marginBottom: '6px' }}><strong>styling</strong> has been disabled for this</div>
            <div style={{ marginBottom: '6px' }}>product. Please use the <strong>edit options</strong></div>
            <div style={{ marginBottom: '6px' }}>to make your edits.</div>
          </div>
        </div>
      }
      placement="top"
    >
      <TooltipText>{props.children}</TooltipText>
    </HtmlTooltip>
  );
}

OptionTooltip.propTypes = {
  children: PropTypes.element.isRequired,
};

export default OptionTooltip;
